import store from '@/store'
import {mostrarIdioma} from '@/utils/utils.js'

export default{
    getCaracteristicasSelect(state){
        let devolver = [];
        for (let caract of state.caracteristicasArray){
            let aux = {
                value : caract.id,
                text : mostrarIdioma(caract.nombre)
            }
            devolver.push(aux);
        }
        return devolver;
    },
    getCaracteristicasSelectGrupo(state){
        let devolver = [];
        let a = state.caracteristicasArray.sort((a,b) => (a.orden > b.orden) ? 1 : ((b.orden > a.orden) ? -1 : 0)); 
        for (let caract of a){
            let grupo = caract.grupo;
            let obj_aux = {
                value : caract.id,
                text : mostrarIdioma(caract.nombre),
                img : caract.imagen,
                grupo : grupo
            }
            let index = devolver.findIndex((e) => e.nombreGrupo == grupo)
            let aux;
            if (index>=0) {
                devolver[index].array.push(obj_aux);
            } else {
                aux = {
                    nombreGrupo : grupo,
                    array : [obj_aux]
                }
                devolver.push(aux);
            }          
        }
        let res = [];
        devolver.forEach(element => {
            let h = element.nombreGrupo;
            res.push(h);
            element.array.forEach(c => {
                res.push(c);
            });
        });
        return res;
    }
}